import { render, staticRenderFns } from "./InboundDocument.vue?vue&type=template&id=759e25e6&scoped=true&"
import script from "./InboundDocument.vue?vue&type=script&lang=js&"
export * from "./InboundDocument.vue?vue&type=script&lang=js&"
import style0 from "./InboundDocument.vue?vue&type=style&index=0&id=759e25e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759e25e6",
  null
  
)

export default component.exports